export default [
  {
    size: { width: 120, height: 600 },
    cropSize: { width: 120, height: 400 },
    descriptionSize: { width: 120, height: 200 },
    positionLogo: { top: 410, left: 45 },
    positionButton: { top: 560},
    hasDescription: true,
    bannerName: "120-600",
    orientation: "portrait",
  },
  {
    size: { width: 180, height: 600 },
    cropSize: { width: 180, height: 400 },
    descriptionSize: { width: 180, height: 200 },
    positionLogo: { top: 0, left: 0 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "180-600",
    orientation: "portrait",
  },
  {
    size: { width: 300, height: 250 },
    cropSize: { width: 300, height: 200 },
    descriptionSize: { width: 300, height: 50 },
    positionLogo: { top: 5, left: 5 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "300-250",
    orientation: "portrait",
  },
  {
    size: { width: 300, height: 600 },
    cropSize: { width: 300, height: 400 },
    descriptionSize: { width: 300, height: 200 },
    positionLogo: { top: 0, left: 0 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "300-600",
    orientation: "portrait",
  },
  {
    size: { width: 970, height: 90 },
    cropSize: { width: 570, height: 90 },
    descriptionSize: { width: 400, height: 90 },
    positionLogo: { top: 0, left: 0 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "970-90",
    orientation: "landscape",
  },
  {
    size: { width: 970, height: 250 },
    cropSize: { width: 600, height: 250 },
    descriptionSize: { width: 370, height: 250 },
    positionLogo: { top: 10, left: 10 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "970-250",
    orientation: "landscape",
  },
  {
    size: { width: 720, height: 300 },
    cropSize: { width: 420, height: 300 },
    descriptionSize: { width: 300, height: 300 },
    positionLogo: { top: 10, left: 10 },
    positionButton: { top: 560, left: 45 },
    hasDescription: true,
    bannerName: "720-300",
    orientation: "landscape",
  },
];
